(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('infinite-scroll-products')) {
    class InfiniteScrollProducts extends HTMLElement {
      constructor() {
        super();
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleIntersection = this.handleIntersection.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('.infinite-scroll-products__button');
        this.buttonLabel = this.button?.querySelector('span');
        this.status = this.querySelector('.infinite-scroll-products__status');
        this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
        this.abortController = new AbortController();
        this.isLoading = false;

        if (!this.button || !this.buttonLabel || !this.status || !this.grid) return;

        this.setAttribute('data-enhanced', 'true');
        this.button.addEventListener('click', this.loadNextPage);

        if (!this.dataset.nextUrl) {
          this.complete();
          return;
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.handleIntersection, { rootMargin: '600px 0px' });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.button?.removeEventListener('click', this.loadNextPage);
      }

      handleIntersection(entries) {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      }

      async loadNextPage() {
        if (this.isLoading || !this.dataset.nextUrl) return;

        this.isLoading = true;
        this.observer?.unobserve(this);
        this.removeAttribute('data-error');
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.buttonLabel.textContent = this.dataset.loadingLabel;
        this.status.textContent = this.dataset.loadingLabel;

        try {
          const url = new URL(this.dataset.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url, {
            signal: this.abortController.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error('Request failed');

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sourceContainer = html.getElementById('ProductGridContainer');
          const sourceGrid = sourceContainer?.querySelector('#product-grid');
          const sourceScroller = sourceContainer?.querySelector('infinite-scroll-products');
          const products = sourceGrid ? Array.from(sourceGrid.children) : [];

          if (!this.isConnected || products.length === 0) {
            if (this.isConnected) this.complete();
            return;
          }

          products.forEach((product) => {
            product.classList.add('scroll-trigger--cancel');
            product.style.removeProperty('--animation-order');
            this.grid.append(product);
          });

          this.dataset.nextUrl = sourceScroller?.dataset.nextUrl || '';
          this.status.textContent = this.dataset.loadedLabel;

          if (!this.dataset.nextUrl) {
            this.complete();
          } else {
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
            this.buttonLabel.textContent = this.dataset.loadLabel;
            this.observer?.observe(this);
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.setAttribute('data-error', 'true');
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.buttonLabel.textContent = this.dataset.retryLabel;
          this.status.textContent = this.dataset.errorLabel;
        } finally {
          this.isLoading = false;
        }
      }

      complete() {
        this.observer?.disconnect();
        this.dataset.nextUrl = '';
        this.setAttribute('data-complete', 'true');
        this.button.hidden = true;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.status.textContent = this.dataset.endLabel;
      }
    }

    customElements.define('infinite-scroll-products', InfiniteScrollProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
